export default __webpack_public_path__ + "static/media/mx_fm3_back.70a35cc5.jpeg";